//import { RichTextInput, DefaultEditorOptions } from "ra-input-rich-text";
import * as React from "react";
import { Pagination, List, Datagrid, TextField, NumberInput, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput } from 'react-admin';

import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import {default as commonStyles} from "./../styles/common.js";
import Stack from '@mui/material/Stack';
import Image from '@tiptap/extension-image'
import {
	DefaultEditorOptions,
	RichTextInput,
	RichTextInputToolbar,
	LevelSelect,
	FormatButtons,
	AlignmentButtons,
	ListButtons,
	LinkButtons,
	QuoteButtons,
	ClearButtons,
} from 'ra-input-rich-text';
import { EditorContent, useEditor } from '@tiptap/react'
import Remove from '@mui/icons-material/Remove';
import { MyEditorOptions, MyRichTextInput } from "../components/myRichTextInput";

import "./../styles/myRichTextInput.css"

/*const MyEditorOptions = {
	...DefaultEditorOptions,
	extensions: [
		...DefaultEditorOptions.extensions,
        Image,
	],
};

const TTMyRichTextInput = ({ size, ...props }) => {
    //let editor = useEditor();
    return (
	<RichTextInput
		editorOptions={MyEditorOptions}
		toolbar={
			<RichTextInputToolbar>
                <LevelSelect size={20} />
			</RichTextInputToolbar>
		}
		{...props}
	/>
)};*/

export const WebsiteContentList = props => (
    <List exporter={false} {...props} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Liste des contenus" />
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="title" label="Titre" />
            <TextField source="slug" />
        </Datagrid>
    </List>
);

export const WebsiteContentEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Édition du contenu" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={{...commonStyles.inputStyle, margin: "auto"}} disabled source="id" label="Id" />
                
                <TextInput style={{...commonStyles.inputStyle, margin: "auto"}} source="title" label="Titre"/>
                <MyRichTextInput editorOptions={MyEditorOptions} source="content" label="Contenu" />
                <TextInput style={{...commonStyles.inputStyle, margin: "auto"}} source="slug" label="Slug (pas d'espaces)"/>

                <ReferenceInput source="category_id" reference="websiteContentCategories">
                    <SelectInput style={{...commonStyles.inputStyle, margin: "auto"}} optionText="name" label="Catégorie" />
                </ReferenceInput>
            </Stack>
        </SimpleForm>
    </Edit>
);

export const WebsiteContentCreate = props => (
    <Create {...props}>
        <PageCreateTitle text="Création d'un contenu" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={{...commonStyles.inputStyle, margin: "auto"}} source="title" label="Titre" />
                <MyRichTextInput editorOptions={MyEditorOptions} source="content" label="Contenu" />
                <TextInput style={{...commonStyles.inputStyle, margin: "auto"}} source="slug" label="Slug (pas d'espaces)"/>

                <ReferenceInput source="category_id" reference="websiteContentCategories">
                    <SelectInput optionText="name" label="Catégorie" style={{...commonStyles.inputStyle, margin: "auto"}} />
                </ReferenceInput>
            </Stack>
        </SimpleForm>
    </Create>
);